import React from 'react';
import MaterialIcon from 'material-icons-react';

import Theme from 'Theme';
import { isComplete } from 'utils';

export const ExpandLess = ({ size = 24, color = Theme.brandColor }) => (
  <MaterialIcon
    icon={'expand_less'}
    color={color}
    size={size}
  />
);

export const ExpandMore = ({ size = 24, color = Theme.brandColor }) => (
  <MaterialIcon
    icon={'expand_more'}
    color={color}
    size={size}
  />
);

export const LockIcon = ({ size = 'small', color = Theme.warningColor }) => (
  <MaterialIcon
    icon={'lock'}
    color={color}
    size={size}
  />
);

export const Search = ({ size = 24, color = Theme.mediumGrey }) => (
  <MaterialIcon
    icon={'search'}
    color={color}
    size={size}
  />
);

export const Info = ({ size = 30, color = Theme.mediumGrey }) => (
  <MaterialIcon
    icon={'info_outline'}
    color={color}
    size={size}
  />
);

export const InputError = ({ size = 30, color = Theme.dangerColor }) => (
  <MaterialIcon
    icon={'error'}
    color={color}
    size={size}
  />
);

export const Back = ({ size = 'large', color = Theme.darkGrey }) => (
  <MaterialIcon
    icon={'arrow_back'}
    color={color}
    size={size}
  />
);

export const Item = ({ size = 'medium', color = Theme.primaryColor }) => (
  <MaterialIcon
    icon={'find_in_page'}
    color={color}
    size={size}
  />
);

export const Complete = ({ className, size = 'medium', color = Theme.successColor }) => (
  <div className={className}>
    <MaterialIcon
      size={size}
      icon={'done'}
      color={color}
    />
  </div>
);

export const Order = ({ size = 'medium', color = Theme.brandColor }) => (
  <MaterialIcon
    icon={'description'}
    color={color}
    size={size}
  />
);

export const Council = ({ size = 'medium', color = Theme.brandColor }) => (
  <MaterialIcon
    icon={'account_balance'}
    color={color}
    size={size}
  />
);

export const Upload = ({ size = 'small', color = Theme.primaryColor }) => (
  <MaterialIcon
    icon={'cloud_upload'}
    color={color}
    size={size}
  />
);

export const Notes = ({ size = 'small', color = Theme.primaryColor }) => (
  <MaterialIcon
    icon={'edit'}
    color={color}
    size={size}
  />
);

export const Add = ({ size = 24, color = '#fff' }) => (
  <MaterialIcon
    icon={'add'}
    color={color}
    size={24}
  />
);

export const Clear = ({ size = 'small', color = Theme.dangerColor }) => (
  <MaterialIcon
    icon={'clear'}
    color={color}
    size={size}
  />
);

export const Remove = ({ size = 'medium', color = Theme.dangerColor }) => (
  <MaterialIcon
    icon={'remove'}
    color={color}
    size={size}
  />
);

export const Cancel = ({ size = 22, color = Theme.mediumGrey }) => (
  <MaterialIcon
    icon={'cancel'}
    color={color}
    size={size}
  />
);

export const Message = ({ size = 'small', color = Theme.primaryColor }) => (
  <MaterialIcon
    icon={'chat'}
    color={color}
    size={size}
  />
);

export const Document = ({ size = 'small', color = Theme.primaryColor }) => (
  <MaterialIcon
    icon={'attachment'}
    color={color}
    size={size}
  />
);

export const Logout = ({ size = 'small', color = '#7093a74d' }) => (
  <MaterialIcon
    icon={'logout'}
    color={color}
    size={size}
  />
);

export const Account = ({ size = 'small', color = '#7093a74d' }) => (
  <MaterialIcon
    icon={'person'}
    color={color}
    size={size}
  />
);

export const Send = ({ size = 'small', color = '#fff' }) => (
  <MaterialIcon
    icon={'arrow_forward'}
    color={color}
    size={size}
  />
);

export const getIcon = status => isComplete(status) && LockIcon;
